import React, { Component } from 'react';
import { withAlert } from 'react-alert';
import Api from '../Api';
import CrudForm from '../Crud/Form';
import ExternalIds from '../ExternalIds';
export default withAlert()(class ExternalIdTable extends Component {
  constructor(props) {
    super(props);
    this.updateState = data => this.setState(data);
    this.toggleExternalId = () => this.setState(prevState => ({
      externalIdOpen: !prevState.externalIdOpen
    }));
    this.verifyId = (externalIdUuid, auth, state, updateState) => {
      const newDisableVerify = Object.assign({}, state.disableVerify);
      newDisableVerify[externalIdUuid] = true;
      updateState({
        disableVerify: newDisableVerify
      });
      const params = {
        uuid: externalIdUuid
      };
      Api.crudUpdate(auth, 'external_ids', params).then(response => {
        if (response.data !== undefined) {
          updateState({
            externalIdLoading: true
          });
          this.props.alert.show('External Id successfully verified', {
            type: 'success'
          });
          ExternalIds.getData(this.options(), updateState);
        } else {
          const errorMessage = 'System error, please try again. If you continue to get this error, open a Help Desk ticket';
          this.props.alert.show(errorMessage, {
            type: 'error'
          });
        }
      }).then(() => {
        newDisableVerify[externalIdUuid] = false;
        updateState({
          disableVerify: newDisableVerify
        });
      });
    };
    this.options = () => {
      const state = this.state;
      const storageName = "otto_".concat(this.props.modelUuid, "_externalIds");
      return {
        state,
        storageName,
        auth: this.props.auth,
        type: this.props.modelType,
        uuid: this.props.modelUuid,
        verify: this.props.canVerify === true ? this.verifyId : undefined,
        disabled: state.disableVerify || {},
        data: state.externalIdData || [],
        loading: state.externalIdLoading,
        tableRef: state.externalIdTableRef,
        open: state.externalIdOpen,
        toggle: this.toggleExternalId,
        updateState: this.updateState,
        hideBottomHr: true
      };
    };
    this.externalIdTable = () => ExternalIds.getTable(this.updateState, this.options());
    this.state = {
      externalIdOpen: true,
      externalIdLoading: true,
      externalIdTableRef: React.createRef()
    };
  }
  render() {
    return this.externalIdTable();
  }
});